module.exports = __webpack_public_path__ + "114cb6477dc1784e982498e9a6e8d254.svg";